// sb-search-storage
sb.DetailsStorage = class extends u.Storage {
    attachedCallback() {
        super.attachedCallback();
        sb.DetailsStorage.instances.push(this);
    }

    $init() {
        this.$set('appRateAverage', this.getAttribute('sb-app-rate-average'));
        this.$set('appRateReviewCount', this.getAttribute('sb-app-rate-review-count'));
        this.$set('appRateByUser', this.getAttribute('sb-app-rate-by-user'));
        this.$set('originalRating', this.getAttribute('sb-app-rate-by-user'));
        this.$set('starHover', -1);
    }
}
sb.DetailsStorage.instances = [];
sb.DetailsStorage.register('sb-details-storage');

sb.ReleaseSelect = class extends u.ForElement {
    attachedCallback() {
        super.attachedCallback();

        this.selectorElement = document.getElementById(this.getAttribute('sb-selector'));
        this.selectorElement.addEventListener('change', (evt) => {
            this.$onChange();
        });

        this.target = this.getAttribute('sb-target');
        this.href = this.getAttribute('sb-href');

        this.$onChange();
    }

    $onChange() {
        if (this.selectorElement.value === this.target) {
            this.classList.remove('u.hide@*');
        } else {
            this.classList.add('u.hide@*');
        }
    }
};
sb.ReleaseSelect.register('sb-release-select');

(class extends sb.ReleaseSelect {
    attachedCallback() {
        super.attachedCallback();

        this.addEventListener('click', (evt) => {
            evt.preventDefault();
            evt.stopPropagation();

            // a hack warning: we need to pass the download link
            // to <form is="sb-details-agree"> and #download-modal is the only
            // elements they share
            this.$forElement._href = this.href;
            this.$forElement.$toggle();
        });
    }

}).register('sb-release-select-click');

(class extends u.BaseForm {
    attachedCallback() {
        super.attachedCallback();

        this._agree = this.querySelector('#agree');
        this._download = this.querySelector('#download');

        const id = this.getAttribute('u-for');
        if(id) {
            this.$forElement = document.getElementById(id);
            this.$forElement.addEventListener('u-modal-open', this.$open.bind(this));
        }
        this._handler = null;
    }

    $open() {
        this.reset();
        if (this._handler) {
            this.removeEventListener('submit', this._handler);
        }

        this._handler = this.$download.bind(this);
        this.addEventListener('submit', this._handler);

        this._agree.classList.remove('u.hide@*');
        this._download.classList.add('u.hide@*');
    }

    $close(evt) {
        evt.preventDefault();
        this.$forElement.$close();
    }

    $download(evt) {
        evt.preventDefault();
        const lead = this.elements["download-lead"].checked;
        const agreeElm = this.elements["download-agree"];

        // BASE-3937 - hack for Safari
        if(agreeElm.checked===true){
            window.location = this.$forElement._href + "?origin=asc&lead=" + lead;
            this._agree.classList.add('u.hide@*');
            this._download.classList.remove('u.hide@*');

            this.removeEventListener('submit', this._handler);

            this._handler = this.$close.bind(this);
            this.addEventListener('submit', this._handler);
        } else {
            // this will only fire in browsers that do not support HTML5 validation
            alert('Please agree to the terms and conditions by clicking the first checkbox.');
        }
    }

}).register('sb-details-agree');

// flag as inappropriate form processing
(class extends u.ModalForm {

    attachedCallback() {
        super.attachedCallback();

    }

    $submit(event) {
        const xhr = new XMLHttpRequest();
        xhr.onreadystatechange = () => {
            if(xhr.readyState === 4) {
                if (xhr.status !== 200) {
                    this.$error("An error occurred. Please try again");
                } else {
                    this.$onSuccess();
                }
            }
        };

        this.elements.submitbtn.value = "Submitting...";

        const formData = new FormData(this);

        xhr.open('POST', `/api/v0/app/${context.appid}/flag/`);
        xhr.setRequestHeader('X-CSRFToken', getCsrfToken());
        xhr.send(formData);
    }

}).register('sb-flag-inappropriate');

(class extends u.Consumer {
    attachedCallback() {
        super.attachedCallback();
        this.$storage.$listen("appRateButtonOn", this.$toggle.bind(this));
    }

    $toggle(value) {
        if (this.classList.contains('open')) {
            this.classList.remove('open');
        } else {
            this.classList.add('open');
        }
    }
}).register('sb-details-star');

(class extends u.Bind {
    attachedCallback() {
        super.attachedCallback();
        this.stars = this.children;
        const clickDisabled = this.getAttribute('sb-click-disabled');

        if (clickDisabled !== "true") {
            for(let i=0; i<this.stars.length; i++) {
                this.stars[i].addEventListener('mouseenter', (evt)=>{
                    this.$mouseenter(i);
                });

                this.stars[i].addEventListener('mouseleave', (evt)=>{
                    this.$mouseleave(i);
                });

                this.stars[i].addEventListener('click', (evt)=>{
                    this.$click(i);
                });
            }
        }
    }

    $click(index) {
        const rating = index + 1;
        const xhr = new XMLHttpRequest();
        const self = this;

        xhr.open('POST', `/api/v0/app/${context.appid}/review/`);
        xhr.onload = () => {
            if (xhr.readyState === 4) {
                const result = JSON.parse(xhr.responseText);
                self.$storage.$set('appRateAverage', result.value);
                self.$storage.$set('appRateReviewCount', result.count);
                self.$storage.$set('appRateByUser', rating);
                self.$storage.$set('appRateButtonOn', false);

                // google analytics
                if (self.$storage.$get('originalRating') === 0) {
                    _gaq.push(['_trackEvent', 'Star-rating', 'rated', String(context.appid), rating]);
                } else {
                    _gaq.push(['_trackEvent', 'Star-rating', 'updated', String(context.appid), rating]);
                }
            }
        };

        var params = `rating=${rating}`;
        xhr.setRequestHeader("X-CSRFToken", getCsrfToken());
        xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
        xhr.send(params);
    }

    $onChange(average) {
        for(let i=0; i<this.stars.length; i++) {
            if (i < average) {
                this.stars[i].classList.add('highlighted');
            } else {
                this.stars[i].classList.remove('highlighted');
            }
        }
    }

    $mouseenter(index) {
        for(let i=0; i<this.stars.length; i++) {
            this.stars[i].classList.add('shadow');
            if(i === index) {
                break;
            }
        }
        this.$storage.$set('starHover', index);
    };

    $mouseleave(index) {
        for(let i=0; i<this.stars.length; i++) {
            this.stars[i].classList.remove('shadow');

            if(i === index) {
                break;
            }
        }
        this.$storage.$set('starHover', -1);
    };
}).register('sb-details-star-buttons');

sb.DetailsStarAnnotation = class extends u.Consumer {
    attachedCallback() {
        super.attachedCallback();
        this.$storage.$listen("appRateByUser", this.$reset.bind(this));
        this.$storage.$listen("starHover", this.$onHover.bind(this));
    }

    $reset(value) {
        let msg = 'You did not rate this app';
        if(value==1){ 
            msg = `You rated this app ${value} star`;
        } else if(value>1){
            msg = `You rated this app ${value} stars`;
        }
        this.innerHTML = msg;
    }

    $onHover(value) {
        if (value >= 0) {
            this.innerHTML = sb.DetailsStarAnnotation.annotation[value];
        } else {
            this.$reset(this.$storage.$get("appRateByUser"));
        }
    }
};

sb.DetailsStarAnnotation.annotation = {
    0: "Doesn't work as expected",
    1: "Works but unstable",
    2: "Works but needs improvement",
    3: "Works as expected",
    4: "Exceeds expectations"
};
sb.DetailsStarAnnotation.register('sb-details-star-annotation');

(class extends u.Bind {
    $onChange(value) {
        if (value > 1) {
            this.textContent = `${value} ratings`;
        } else {
            this.textContent = `${value} rating`;
        }
    }
}).register('sb-details-star-review-count');

(class extends u.BaseElement {
    attachedCallback() {
        super.attachedCallback();

        this.addEventListener('click', (evt) => {
            this.action = this.getAttribute('data-value');

            const xhr = new XMLHttpRequest();
            xhr.open('POST', `/api/v0/app/${context.appid}/subscription/`);

            var params = `action=${this.action}`;
            xhr.setRequestHeader("X-CSRFToken", getCsrfToken());
            xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded; charset=UTF-8");
            xhr.send(params);

            xhr.onload = () => {
                if (xhr.readyState === 4 && xhr.status === 204) {
                    var subscribe_buttons = document.getElementsByTagName('sb-subscribe-button');
                    if (this.action === 'subscribe') {
                        for (var i = 0; i < subscribe_buttons.length; i++) {
                            subscribe_buttons[i].setAttribute('data-value', 'unsubscribe');
                            subscribe_buttons[i].textContent = 'Unsubscribe';
                        }
                    } else if (this.action === 'unsubscribe') {
                        for (var i = 0; i < subscribe_buttons.length; i++) {
                            subscribe_buttons[i].setAttribute('data-value', 'subscribe');
                            subscribe_buttons[i].textContent = 'Subscribe';
                        }
                    }
                }
            };
        });
    }
}).register('sb-subscribe-button');

(class extends u.BaseElement {
    // controls youtube iframe on an event
    //
    // on: specify an event in id:event. multiple events can be listed with space in between
    // action: choose an action (name of a function name of the youtube API)

    createdCallback() {
        super.createdCallback();
        const events = this.getAttribute('on').split(' ');
        this.action = this.getAttribute('action');
        this.player = null;
        this.isPlayerReady = false;
        for (let event of events) {
            const eventPair = event.split(':');
            const targetID = eventPair[0];
            const eventName = eventPair[1];
            const element = document.getElementById(targetID);
            element.addEventListener(eventName, this.handler.bind(this));
        }
    }

    handler() {
        // we can't construct YT object during createdCallback time because
        // the dom is not fully constructed at that point
        if(!this.player) {
            this.player = new YT.Player(this.firstElementChild.id, {
                events: {
                    'onReady': this.onPlayerReady.bind(this),
                }
            });
        }

        // control functions can only be used when once the player is ready.
        // don't do anything if the player is not ready
        if (this.isPlayerReady) {
            const state = this.player.getPlayerState();

            // if the player is just in cued state, don't pause it. it will remove
            // the "play" button in the center of the iframe
            if (state !== YT.PlayerState.CUED) {
                this.player[this.action]();
            }
        }
    }

    onPlayerReady(event) {
        this.isPlayerReady = true;
    }

}).register('sb-youtube');

window.addEventListener('WebComponentsReady', function (e) {
    for(let instance of sb.DetailsStorage.instances) {
        instance.$init();
    }
});
